import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { useRole } from '@/hooks/auth'
import { Role } from '@/constants/role'

import SetComponent from './SetComponent'

const UPDATE_KEY = 'prReadable'

const SetReadable = () => {
  const { id } = useParams('')
  const { data: user } = useSWR([`/users/${id}/full`])

  const isBuyerLeader = useRole(Role.BuyerLeader)
  if (!isBuyerLeader) return null

  return <SetComponent user={user} updateKey={UPDATE_KEY} />
}

export default SetReadable
